// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".success-page-container[data-v-4b9ad6d2]{text-align:center}.success-page-container .result-popup p[data-v-4b9ad6d2]{margin-top:15px}.success-page-container .info[data-v-4b9ad6d2]{font-size:16px;line-height:22px}.success-page-container .add-details[data-v-4b9ad6d2]{font-size:18px;line-height:24px}.success-page-container .details-info[data-v-4b9ad6d2]{max-width:350px;margin:0 auto}.success-page-container .cta[data-v-4b9ad6d2]{width:271px;margin:24px auto}", ""]);
// Exports
module.exports = exports;
